import * as React from "react";
import {RefObject} from "react";
import {Typography} from "@mui/material";
import {useTranslation} from "react-i18next";
import ProductionIcon from "../../../../components/Icons/ProductionIcon";

import theme from "../../../../components/styles/theme/theme";
import {isRegion} from "../../../../config";

type Props = {
  consumerRetailValueRef: RefObject<HTMLHeadingElement>;
  facilitiesRef: RefObject<HTMLHeadingElement>;
  spentOnDomesticSuppliersRef: RefObject<HTMLHeadingElement>;
  unitCasesProducedRef: RefObject<HTMLHeadingElement>;
  litersProducedRef: RefObject<HTMLHeadingElement>;
  hideBottlingPartners?: boolean;
};

export const ProductionBox: React.FC<Props> = ({
                                                 consumerRetailValueRef,
                                                 facilitiesRef,
                                                 spentOnDomesticSuppliersRef,
                                                 unitCasesProducedRef,
                                                 litersProducedRef,
                                                 hideBottlingPartners,
                                               }: Props) => {
  const {t} = useTranslation();

  return (
    <div className="production">
      <div className="production_title">
        <Typography
          sx={{
            fontWeight: "600",
          }}
        >
          {isRegion.usa ? t("boxes.production_usa") : t("boxes.production")}
          <ProductionIcon
            color={theme.palette.secondary.main}
            height="15px"
            width="15px"
            style={{ width: '25px'}}
          />
        </Typography>
      </div>
      {!hideBottlingPartners && (
        <div className="production_facilities">
          <Typography
            variant="h4"
            component="h4"
            color={theme.palette.secondary["600"]}
            ref={facilitiesRef}
          >
            0
          </Typography>
          <Typography variant="body2" component="p">
            {isRegion.usa ? t("common.bottling_partners") : t("common.facilities")}
          </Typography>
        </div>
      )}
      {!isRegion.usa && (
        <div className="production_unit">
          <Typography
            variant="h4"
            component="h4"
            color={theme.palette.secondary["600"]}
            ref={isRegion.latam ? unitCasesProducedRef : litersProducedRef}
          >
            0
          </Typography>
          <Typography variant="body2" component="p">
            {isRegion.latam
              ? t("boxes.unit_cases_produced")
              : t("boxes.liters_produced")}
          </Typography>
        </div>
      )}
      <div className="production_consumer">
        <Typography
          variant="h4"
          component="h4"
          color={theme.palette.secondary["600"]}
          ref={consumerRetailValueRef}
        >
          0
        </Typography>
        <Typography variant="body2" component="p">
          {t("boxes.consumer_retail_value")}
        </Typography>
      </div>
      <div className="production_spent">
        <Typography
          variant="h4"
          component="h4"
          color={theme.palette.secondary["600"]}
          ref={spentOnDomesticSuppliersRef}
        >
          0
        </Typography>
        <Typography variant="body2" component="p">
          {t("boxes.spent_on_domestic_suppliers")}
        </Typography>
      </div>
    </div>
  );
};
